import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // <--- THIS LINE MUST BE PRESENT AND UNCOMMENTED
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Optional: If you have a 'reportWebVitals', you can uncomment and use it if needed.
// import reportWebVitals from './reportWebVitals';
// reportWebVitals();
